import { combineReducers } from "redux";
import user from "./user";
import notification from "./notification";
import language from "./lang";
import culture from "./culture";

export default combineReducers({
  user,
  notification,
  language,
  culture
});
